// 机经题库列表父类列表

import { getUserInfoApi, type UserInfo } from "@/api/user";
import { defineStore } from "pinia";
import { computed, ref } from "vue";

export const useUserStore = defineStore(
  "user",
  () => {
    const userInfo = ref<UserInfo>();
    const getUserInfo = () => {
      getUserInfoApi().then((res) => {
        userInfo.value = res.data;
        // userInfo.value.newMemberLevel = 1;
      });
    };
    /**
     * 是否为会员
     */

    const isMembers = computed(() => {
      if (userInfo.value && userInfo.value.newMemberLevel > 0) {
        return true;
      }
      return false;
    });
    return {
      userInfo,
      isMembers,
      getUserInfo,
    };
  },
  {
    persist: {
      storage: localStorage,
      paths: ["userInfo"],
    },
  }
);
